/** 推拿性别：接口 gender 0 / 1 / 2 */
export const TUINA_GENDER_OPTIONS = [
  { id: 0, value: '未知' },
  { id: 1, value: '男' },
  { id: 2, value: '女' }
]

/** 技师 status：on_duty / off_duty */
export const TUINA_THERAPIST_STATUS_OPTIONS = [
  { id: 'on_duty', value: '在岗', color: 'success' },
  { id: 'off_duty', value: '离岗', color: 'default' }
]

/** 预约 status：booked / completed / cancelled / no_show */
export const TUINA_RESERVATION_STATUS_OPTIONS = [
  { id: 'booked', value: '已预约', color: 'blue' },
  { id: 'completed', value: '已完成', color: 'success' },
  { id: 'cancelled', value: '已取消', color: 'default' },
  { id: 'expired', value: '已过期', color: 'default' }
]

/** 与三乔看板预约「最近问题」同一份；C 端推拿预约多填这些 */
export const TUINA_RECENT_ISSUES = [
  '内分泌失调',
  '肩颈酸痛',
  '肌肉紧张',
  '腰痛',
  '腿痛',
  '头痛',
  '失眠',
  '哮喘',
  '胃胀',
  '其它'
]

export const TUINA_RECENT_ISSUE_OPTIONS = TUINA_RECENT_ISSUES.map((text) => ({
  id: text,
  value: text
}))

/** 购买支付方式 payMethod */
export const TUINA_PAY_METHOD_OPTIONS = [
  { id: 'wechat', value: '微信' },
  // { id: 'alipay', value: '支付宝' },
  { id: 'cash', value: '现金' }
]

/** 购买订单 payStatus：unpaid / paid / refunded */
export const TUINA_PAY_STATUS_OPTIONS = [
  { id: 'unpaid', value: '待支付', color: 'warning' },
  { id: 'paid', value: '已支付', color: 'success' },
  { id: 'refunded', value: '已退款', color: 'default' }
]
